import React from 'react';
import { useDispatch } from 'react-redux';

import { removeCourtExclusionList, addCourtExclusionList } from '../../../actions/draw-edit-actions';

const ExcludedCourt = ({
    court,
    excludedCourtIds,
    setExcludedCourtIds,
}) => {
    const dispatch = useDispatch();
    const handleClick = () => {
        let newExcludedIds = [];

        if (excludedCourtIds.includes(court.id)) {
            newExcludedIds = excludedCourtIds.filter(courtId => {
                return courtId !== court.id;
            });

            dispatch(removeCourtExclusionList([court.id]));
        } else {
            newExcludedIds = [...excludedCourtIds, court.id];
            dispatch(addCourtExclusionList([court.id]));
        }

        setExcludedCourtIds(newExcludedIds);
    };

    return (
        <div className="utr-card p16 clickable" onClick={handleClick} data-testid={`locations.court-${court.id}`}>
            <div className="menu-label d-flex align-items-center">
                <div className={`radio-check ${!excludedCourtIds.includes(court.id) ? 'checked' : ''}`}>
                    <img src="/img/icons/checkmark-icon.svg" />
                </div>
                <div className="text-gray" data-testid={`locations.court-${court.id}.name`}>{court.name}</div>
            </div>
        </div>
    );
};

export default ExcludedCourt;
